// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderDetail_container__zj3n8 {
  animation: ProviderDetail_init__fOo9n 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 16px;
}

/*---Title---*/
.ProviderDetail_container__zj3n8 .ProviderDetail_titleContainer__fzV4K {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_titleContainer__fzV4K .ProviderDetail_title__Cn2yd {
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_titleContainer__fzV4K .ProviderDetail_title__Cn2yd h4 {
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-right: 20px;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_titleContainer__fzV4K .ProviderDetail_title__Cn2yd .ProviderDetail_chip__bjZMD {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  border-radius: 10px;
  width: 6rem;
  height: 2.5rem;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_titleContainer__fzV4K .ProviderDetail_arrow__HS78Y {
  transition: 0.3s;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_titleContainer__fzV4K .ProviderDetail_arrow__HS78Y:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_data__a6\\+tz {
  margin-bottom: 10px;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_data__a6\\+tz .ProviderDetail_accordion__z99JY {
  width: 100%;
  margin-bottom: 20px;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_data__a6\\+tz .ProviderDetail_dataContainer__Yy-Go {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  background-color: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
  padding-bottom: 30px;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_data__a6\\+tz .ProviderDetail_dataContainer__Yy-Go .ProviderDetail_item__PMk99 {
  margin-top: 20px;
  width: 200px;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_data__a6\\+tz .ProviderDetail_dataContainer__Yy-Go .ProviderDetail_item__PMk99 h3 {
  font-size: 1.2rem;
  margin: 0;
  margin-bottom: 10px;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_data__a6\\+tz .ProviderDetail_dataContainer__Yy-Go .ProviderDetail_item__PMk99 p {
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
  font-family: Roboto, sans-serif;
}

/*---Información---*/
.ProviderDetail_container__zj3n8 .ProviderDetail_dataContainer__Yy-Go .ProviderDetail_tableContainer__7fvyL {
  border-radius: 10px;
  margin-bottom: 50px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.ProviderDetail_container__zj3n8 .ProviderDetail_loader__jabMM {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.ProviderDetail_container__zj3n8 .ProviderDetail_gameName__AxZsU {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 300;
}

@keyframes ProviderDetail_init__fOo9n {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Proveedores/Detail/ProviderDetail.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  font-size: 16px;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer .title {\n  width: 95%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .titleContainer .title h4 {\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-right: 20px;\n}\n\n.container .titleContainer .title .chip {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1rem;\n  border-radius: 10px;\n  width: 6rem;\n  height: 2.5rem;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .data {\n  margin-bottom: 10px;\n}\n\n.container .data .accordion {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.container .data .dataContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  align-items: center;\n  background-color: white;\n  border-radius: 0 0 10px 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n  padding-bottom: 30px;\n}\n\n.container .data .dataContainer .item {\n  margin-top: 20px;\n  width: 200px;\n}\n\n.container .data .dataContainer .item h3 {\n  font-size: 1.2rem;\n  margin: 0;\n  margin-bottom: 10px;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .data .dataContainer .item p {\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 500;\n  font-family: Roboto, sans-serif;\n}\n\n/*---Información---*/\n.container .dataContainer .tableContainer {\n  border-radius: 10px;\n  margin-bottom: 50px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .loader {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 30px;\n}\n\n.container .gameName {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 1.3rem;\n  font-weight: 300;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ProviderDetail_container__zj3n8`,
	"init": `ProviderDetail_init__fOo9n`,
	"titleContainer": `ProviderDetail_titleContainer__fzV4K`,
	"title": `ProviderDetail_title__Cn2yd`,
	"chip": `ProviderDetail_chip__bjZMD`,
	"arrow": `ProviderDetail_arrow__HS78Y`,
	"data": `ProviderDetail_data__a6+tz`,
	"accordion": `ProviderDetail_accordion__z99JY`,
	"dataContainer": `ProviderDetail_dataContainer__Yy-Go`,
	"item": `ProviderDetail_item__PMk99`,
	"tableContainer": `ProviderDetail_tableContainer__7fvyL`,
	"loader": `ProviderDetail_loader__jabMM`,
	"gameName": `ProviderDetail_gameName__AxZsU`
};
export default ___CSS_LOADER_EXPORT___;
